import React from 'react'
import Badge from 'react-bootstrap/Badge'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Spinner from 'react-bootstrap/Spinner'

/**
 * Consolidated status badge for long-running processes (exports, reports, etc.).
 * Displays an icon + text pill badge colored by status.
 *
 * @param {object} props
 * @param {string} props.status - Current status key
 * @param {object} props.statusConfig - Map of status → { icon, text, color, spin? }
 *   Each entry: { icon: faIcon, text: 'Label', color: 'text-success', spin?: boolean }
 *   Special: if icon is null, a Spinner is rendered instead.
 */
const ProcessStatusBadge = ({ status, statusConfig }) => {
  const config = statusConfig[status]
  if (!config) return null

  if (!config.icon) {
    return <Spinner animation="border" variant="primary" size="sm" />
  }

  return (
    <Badge pill className={`${config.color} bg-light`}>
      <FontAwesomeIcon icon={config.icon} spin={config.spin} className="me-1" />
      {config.text}
    </Badge>
  )
}

export default ProcessStatusBadge
